/**
 * TODO :
 * add google analytics
 */

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueClipboard from 'vue-clipboard2'
import VueAnalytics from 'vue-analytics'


import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import {
	library
} from '@fortawesome/fontawesome-svg-core'
import {
	FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import {
	faArrowRight,
	faLink,
	faPaperPlane,
	faShareAlt,
	faChalkboardTeacher,
	faBook,
	faHandshake,
	faUserAlt,
	faLaptopHouse
} from '@fortawesome/free-solid-svg-icons'
import {
	faEnvelope
} from '@fortawesome/free-regular-svg-icons'
import {
	faTwitter
} from '@fortawesome/free-brands-svg-icons'

import './assets/sass/index.sass'

VueClipboard.config.autoSetContainer = true

Vue.use(BootstrapVue)
Vue.use(VueClipboard)

const isProd = process.env.NODE_ENV === 'production'
const analyticsId = "UA-38636234-4"

//load Google Analytics
Vue.use(VueAnalytics, {
	id: analyticsId,
	debug: {
		sendHitTask: isProd,
		enabled: !isProd
	},
	router
})

library.add([faArrowRight, faTwitter, faEnvelope, faLink, faPaperPlane, faShareAlt, faChalkboardTeacher, faBook, faHandshake, faUserAlt, faLaptopHouse])
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

new Vue({
	router,
	render: h => h(App)
}).$mount("#app");